import { ValidityType } from '../types/unified-financial';

export const formatPhoneNumber = (phone: string): string => {
  // Remove all non-numeric characters
  const numbers = phone.replace(/\D/g, '');

  // Format as (XX) XXXXX-XXXX
  if (numbers.length === 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }

  // Format as (XX) XXXX-XXXX
  if (numbers.length === 10) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
  }

  return phone; // Return original if format doesn't match
};

export const formatValidityDisplay = (validityType: ValidityType, customValidityMonths?: number): string => {
  switch (validityType) {
    case '1_MONTH':
      return '1 mês';
    case '2_MONTHS':
      return '2 meses';
    case '3_MONTHS':
      return '3 meses';
    case 'CUSTOM':
      if (customValidityMonths) {
        return `${customValidityMonths} ${customValidityMonths === 1 ? 'mês' : 'meses'}`;
      }
      return 'Personalizado';
    default:
      return 'Não definido';
  }
};

export const parseLocalDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatDateToLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};